export default __webpack_public_path__ + "static/media/streamer_avatar4.0fcb633a.png";